module.exports = __webpack_public_path__ + "media/icons/widget-section-b-3a436652.png";